import React from "react";
import { SidebarContainers } from "@components";
import { SizesSideBarProps } from "./types";
import { STRING } from "@constants";
import { UnitDescriptionForm } from "./UnitDescriptionForm";

export function UnitDescriptionSideBar({
  show,
  onClose,
  editValues,
}: SizesSideBarProps) {
  return (
    <SidebarContainers
      show={show}
      onClose={onClose}
      title={
        editValues
          ? STRING.UNIT_DESCRIPTION_FORM.TITLE_UPDATE
          : STRING.UNIT_DESCRIPTION_FORM.TITLE_CREATE
      }
    >
      <UnitDescriptionForm onClose={onClose} editValues={editValues} />
    </SidebarContainers>
  );
}
